<template>
  <div id="feedback">
    <el-tabs v-model="tabAction" >
      <el-tab-pane
        v-for="item in tabs"
        :key="item.name"
        :label="item.label"
        :name="item.name"
      >
      </el-tab-pane>
    </el-tabs>
    <component :is="tabAction"></component>
  </div>
</template>

<script>
import driverFeedback from "./driverFeedback.vue";
export default {
  name: "feedback",
  components: {
    driverFeedback,
  },
  data() {
    return {
      tabs: [
        {
          label: "司机反馈",
          name: "driverFeedback",
        },
      ],
      tabAction: "driverFeedback",
    };
  },

  methods: {},
};
</script>

<style>

</style>